// 部分页面自定义颜色
// 1. 接口字段 -> CSS 变量名 的映射
export const THEME_MAP = {
  btnColor:'--cust-btn',
  btnText:'--cust-btn-text',
}
// 2. 默认值（接口失败 / 字段缺失时兜底）
const DEFAULT_THEME = {
  btnColor: '#ec1c1c',
  btnText: '#fff',
  // btnColor: '#ff5722',
  // btnText: '#0F0401',
}
// 3. 记录当前使用css变量
export let CURRENT_THEME = {}
/**
 * 把接口数据转成可直接绑到 :style 的对象
 * @param {Object} data 接口返回的扁平对象
 * @returns {Object} { '--color-primary': '#f00', ... }
 */
export function buildThemeStyle(data = {}) {
  const merged = { ...DEFAULT_THEME, ...data }
  const style = {}
  Object.keys(THEME_MAP).forEach(key => {
    if (merged[key]) {
      style[THEME_MAP[key]] = merged[key]
    }
  })
  return style
}
/** 设置当前主题css变量 */
export function setCurrentTheme(data = {}) {
  CURRENT_THEME = buildThemeStyle(data)
  return CURRENT_THEME
}

/**  读取当前css变量 */
export function getCurrentTheme() {
  return CURRENT_THEME
}


// WEBPACK FOOTER //
// ./assets/js/utils/customTheme.js